import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IBasicDetails } from '../../../../interface/interfaces';
import { getAllParents } from '../../TreeComposite/TreeWidget/utils/getAllParents';


interface IInputData {
    parents: IBasicDetails[]
}


interface IInputDataForChildrens extends IInputData {
    nodes: IBasicDetails[],
}

interface IInputDataForChild extends IInputData {
    node: IBasicDetails
}


interface IInitialState {
    dataAllChildrensPerNode: IBasicDetails[];
    nodeParents: IBasicDetails[]
}

const initialState: IInitialState = {
    dataAllChildrensPerNode: [],
    nodeParents: []
};

const allChildrensPerNodeSlice = createSlice({
    name: 'AllChildrensPerNode',
    initialState,
    reducers: {
        // Selection by type
        addAllChildrens: (state: IInitialState, action: PayloadAction<IInputDataForChildrens>) => {
            // multiple selection
            // state.dataAllChildrensPerNode = [...state.dataAllChildrensPerNode, ...action.payload.nodes];
            state.dataAllChildrensPerNode = action.payload.nodes;
            const foundParents = getAllParents([...state.dataAllChildrensPerNode], action.payload.parents)
            state.nodeParents = foundParents
        },

        // Single selection
        addChild: (state: IInitialState, action: PayloadAction<IInputDataForChild>) => {

            // NODES
            const getId = state.dataAllChildrensPerNode.map((item: IBasicDetails)=>{
                return item.Id
            })
            
            if(!getId.includes(action.payload.node.Id)){
                state.dataAllChildrensPerNode = [...state.dataAllChildrensPerNode, action.payload.node];
            }else{
                state.dataAllChildrensPerNode = state.dataAllChildrensPerNode.filter((item: IBasicDetails)=>{
                    return item.Id !== action.payload.node.Id
                })
            }
            
            // PARENTS
            const foundParents = getAllParents([...state.dataAllChildrensPerNode], action.payload.parents)
            state.nodeParents = foundParents
        },

        clearChildrens: (state: IInitialState) => {
            state.dataAllChildrensPerNode = [];
            state.nodeParents = []
        },
    },
});

export default allChildrensPerNodeSlice.reducer;
export const { addAllChildrens, clearChildrens, addChild } = allChildrensPerNodeSlice.actions;
